import { SecondarySmallButton } from 'components/ReusableComponents/Button/SmallButtons'
import EditIcon from 'components/ReusableComponents/Icons/Edit'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { formatNumberAsThousands } from 'utils/priceHelpers'

import styles from './AudienceCard.module.scss'

const AudienceCard = ({ name, id, size = 0, isProtected = false }) => {
  const metaParts = []
  if (size > 0) {
    metaParts.push(`${formatNumberAsThousands(size)} guests`)
  }
  if (isProtected) {
    metaParts.push('Default audience')
  }

  return (
    <div className={styles.card}>
      <div className={styles.content}>
        <p className={styles.name}>{name}</p>
        {metaParts.length > 0 && (
          <p className={styles.description}>{metaParts.join(' · ')}</p>
        )}
      </div>
      <div className={styles.controls}>
        <Link to={`/custom-audience/${id}`}>
          <SecondarySmallButton>
            {!isProtected && <EditIcon />} {isProtected ? 'View' : 'Edit'}
          </SecondarySmallButton>
        </Link>
      </div>
    </div>
  )
}

AudienceCard.propTypes = {
  id: PropTypes.number,
  name: PropTypes.string,
  size: PropTypes.number,
  isProtected: PropTypes.bool
}

export default AudienceCard
